import { render, staticRenderFns } from "./MyNotes.vue?vue&type=template&id=2de8d85c"
import script from "./MyNotes.vue?vue&type=script&lang=js"
export * from "./MyNotes.vue?vue&type=script&lang=js"
import style0 from "./MyNotes.vue?vue&type=style&index=0&id=2de8d85c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports